module.exports = __webpack_public_path__ + "static/media/pending-orders.6ea980a8.svg";